import type { BrandSpecialRules, BrandSpecialType } from '@iheartjane/types';

import { extractUserSegments } from './extractUserSegments';

export const brandSpecialHasSegments = ({
  rules,
  specialType,
}: {
  rules: BrandSpecialRules;
  specialType: BrandSpecialType;
}) => {
  const { includes, excludes } = extractUserSegments({
    rules,
    specialType,
  });

  const noIncludedSegments = !includes?.length;
  const noExcludedSegments = !excludes?.length;

  const needsSegments = !noIncludedSegments || !noExcludedSegments;

  return needsSegments;
};
